export const REACT_URL =  process.env.REACT_APP_FRONTEND_URL;
export const SERVICE_URL =  process.env.REACT_APP_BACKEND_URL;
export const GET_PRODUCT_DETAILS_URL = SERVICE_URL + "api/product/product-details";
export const GET_COUNTRY_DETAILS = SERVICE_URL + "api/trace/check";
export const PROTECT_DATA = SERVICE_URL + "api/protect/payload";
export const GENERATE_TRACE_CODE = SERVICE_URL + "api/trace/generate/";
export const GET_CIRPASS_DATA = SERVICE_URL + "api/Integration/digitalproductpassport/cirpass-histories";
export const GET_FRANCE_DPP = SERVICE_URL + "api/Integration/digitalproductpassport/custom-france-dpp";
export const GET_ALL_COUNTRIES = SERVICE_URL + "api/localization/get/countries";
export const GET_HOMEPAGE_LINKS = SERVICE_URL + "api/localization/home-page-links";





